export default __webpack_public_path__ + "static/media/user-icon.9fd9547f.svg";